
var swiper = new Swiper(".articleSlider", {
  slidesPerView: "auto",
  // slidesPerView: 3,
  // spaceBetween: 30,
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

//swiper js implementation code here
let sliderOne = new Swiper(".deatailImagCarousel", {
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
  // ,
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true
  // }
});
let sliderTwo = new Swiper(".deatailCarousel", {
  loop: false,
  slidesPerView: 1,
  grabCursor: true,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // when window width is >= 480px
    480: {
      slidesPerView: 1
    },
    // when window width is >= 640px
    750: {
      slidesPerView: 1
    }
  }
});

sliderOne.controller.control = sliderTwo;
sliderTwo.controller.control = sliderOne;

var reviewCarousel = new Swiper(".reviewCarousel", {
  // slidesPerView: "auto",
  slidesPerView: 1,
  grabCursor: true,
  spaceBetween: 24,
  breakpoints: {
    // when window width is >= 480px
    480: {
      slidesPerView: 2
    },
    // when window width is >= 640px
    750: {
      slidesPerView: 3,
      spaceBetween: 54,
    }
  }
});




// Custom Marquee Section 

function Marquee(selector, speed) {

  // Get all elements with the marquee class
  const marquees = document.querySelectorAll(selector);

  // Loop through each one
  marquees.forEach(marquee => {

    const clone = marquee.innerHTML;

    const firstElement = marquee.children[0];
        
    marquee.insertAdjacentHTML('beforeend', clone);
    marquee.insertAdjacentHTML('beforeend', clone);

    let i = 0;
        
    setInterval(function() {

      firstElement.style.marginLeft = `-${i}px`;

      if (i > firstElement.clientWidth) {
        i = 0; 
      }
        
      i = i + speed;
        
    }, 0);

  });

}

//after window is completed load
//1 class selector for marquee
//2 marquee speed 0.2
window.addEventListener('load', () => {
  Marquee('.marquee', 0.2); 
});



document.addEventListener('DOMContentLoaded', function () {
  const videoPopupBtn = document.querySelector('.video-popup-btn');
  const videoPopup = document.querySelector('.video-popup');
if(videoPopup && videoPopupBtn){
  // Add click event listener to the video-popup-btn
  videoPopupBtn.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevent the click event from propagating to the document
    videoPopup.classList.toggle('active'); // Toggle the "active" class
});

// Add click event listener to the document to close the popup when clicking outside
document.addEventListener('click', function (event) {
    if (!videoPopup.contains(event.target) && event.target !== videoPopup) {
        videoPopup.classList.remove('active');
    }
});

// Prevent clicks inside the video popup from closing it
videoPopup.addEventListener('click', function (event) {
    event.stopPropagation();
});
}

});


  const closedElements = document.querySelectorAll('.tool-svg-wrap .closed');
  if(closedElements){
    closedElements.forEach((closedElement) => {
      closedElement.addEventListener('mouseenter', () => {
        const tooltipElement = closedElement.closest('.tooltip');
        if (tooltipElement) {
          tooltipElement.classList.add('active');
        }
      });
  
      closedElement.addEventListener('mouseleave', () => {
        const tooltipElement = closedElement.closest('.tooltip');
        if (tooltipElement) {
          tooltipElement.classList.remove('active');
        }
      });
    });
  }

window.addEventListener('DOMContentLoaded',function(){
  const arrow=document.querySelector('.arrow')
       const body = document.querySelector("body");
      const HTML = "<style>html,body{scroll-behavior:smooth}</style>";
      body?.insertAdjacentHTML("beforeend", HTML);
      if (window.innerWidth > 650) {
        const one = document.querySelector(".one");

        const two = document.querySelector(".two");
        const three = document.querySelector(
          "#fuck"
        )?.closest('section');

        let oneRec = one.getBoundingClientRect();
        let twoRec = two.getBoundingClientRect();
        let threeRec = three?.getBoundingClientRect();

        oneRec = oneRec.y + window.pageYOffset
        twoRec = twoRec.y + window.pageYOffset
        threeRec = threeRec.y + window.pageYOffset

        arrow.addEventListener('click',function(){
          if(Math.round(window.scrollY) >= Math.round(twoRec)){
            window.scrollTo(0,threeRec)
          }else{
            
          window.scrollTo(0,twoRec);
          }
          console.log(Math.round(window.scrollY),'aaaaaaaaaaaaaaa',Math.round(twoRec))
        })
        window.addEventListener("resize", function (e) {
          if (e.target.innerWidth > 768) {
            oneRec = one.getBoundingClientRect();
            twoRec = two.getBoundingClientRect();
            threeRec = three?.getBoundingClientRect();

              oneRec = oneRec.y + window.pageYOffset
        twoRec = twoRec.y + window.pageYOffset
        threeRec = threeRec.y + window.pageYOffset
            console.log(oneRec, "resizeeeeeeeeeeeeeeeee");
          }else{
                        oneRec =null;
            twoRec = null
            threeRec = null
}
        });
        console.log(three, "=====================================", threeRec);
        function obsCall([entry]) {
          if (entry.isIntersecting) {
            // console.log(oneRec, "oneeeeeeee");
            window.scrollTo(0,oneRec);
            console.log(entry.boundingClientRect);
          }
        }
        function obsCallT([entry]) {
          if (entry.isIntersecting) {
            // console.log(twoRec, "twoppppppppppp");
            window.scrollTo(0,twoRec);
            console.log(entry.boundingClientRect);
          }
        }
        function obsCallTh([entry]) {
          if (entry.isIntersecting) {
            // console.log(threeRec);
            window.scrollTo(0, threeRec);
            console.log(entry.boundingClientRect);
          }
        }
        const observor = new IntersectionObserver(obsCall, {
          root: null,
          threshold: [0.25],
        });
        const obsT = new IntersectionObserver(obsCallT, {
          root: null,
          threshold: [0.25],
        });
        const obsTh = new IntersectionObserver(obsCallTh, {
          root: null,
          threshold: 0.1,
        });
        observor.observe(one);
        obsT.observe(two);
        obsTh.observe(three);
      }
      setTimeout(function () {
        oneRec = document.querySelector(".one").getBoundingClientRect();
        twoRec = document.querySelector(".two").getBoundingClientRect();
        threeRec = document
          .querySelector(
            "#shopify-section-template--16120347951269__ccf0c432-8989-4d91-998a-f0368a17ec32"
          )
          ?.getBoundingClientRect();
        console.log(oneRec, "hahahahahahahahahhaa");
      }, 2000);
})
